import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=cbcf3d9c&scoped=true"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordView.vue?vue&type=style&index=0&id=cbcf3d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcf3d9c",
  null
  
)

export default component.exports